import React from "react";
import Card from "./Card";
import HeroSection from "./HeroSection";
import Breadcrumb from "./Breadcrumb";
import { Link, Outlet} from "react-router-dom";
function EmbeddedSystems() {
  return (

    <div className="aboutInfo">

    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Embedded Systems"
        backgroundImage="/img/embedded.jpg"
      />
      
      <Breadcrumb current="Embedded" />
    

      {/* Cards Section */}
      <div className="container services">
        <div className="card-cover">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-4 mb-2">
              <Link to="Hardware-Design" className="card-link" style={{ textDecoration: "none", color: "inherit" }}>
                <Card
                  title="Hardware Design Services"
                  img="motherboard.png"
                  text="Hardware Design Services involve creating tailored electronic circuits, PCB layouts, and system designs to meet specific performance, reliability, and functionality requirements for various industries."
                  showButton={true}
                />
                </Link>
                <Outlet/>
              </div>
              <div className="col-md-4 mb-2">
              <Link to="Firmware-Design" className="card-link" style={{ textDecoration: "none", color: "inherit" }}>
                <Card
                  title="Firmware Design Services"
                  img="processor.png"
                  text="Seionic Technologies provides end-to-end firmware design services, including custom hardware development and seamless software integration, ensuring optimal performance and reliability for embedded systems."
                  showButton={true}
                />
                </Link>
                <Outlet/>
              </div>
              <div className="col-md-4 mb-2">
              <Link to="Testing" className="card-link" style={{ textDecoration: "none", color: "inherit" }}>
                <Card
                  title="Testing and Validation"
                  img="software.png"
                  text="Seionic Technologies ensures the highest quality through comprehensive testing and validation services, delivering reliable, error-free, and performance-optimized solutions tailored to meet industry standards and client requirements."
                  showButton={true}
                />
                </Link>
                <Outlet/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default EmbeddedSystems;
